import { IOrganizationChartNode } from '../../../../../app/resource/node/node.types';

/** Builds a stable layout-sync fingerprint so UI nodes reset only when meaningful chart data changes. */
export function getChartLayoutFingerprint(
  chartType: string,
  nodeIds: string[],
  nodes: IOrganizationChartNode[],
): string {
  return JSON.stringify({
    chartType,
    nodeIds: [...nodeIds].sort(),
    nodeSnapshots: nodes.map((node) => ({
      id: node.id,
      positionX: node.positionX,
      positionY: node.positionY,
      parentIds: node.parentIds,
      nodeTitle: node.nodeTitle,
      description: node.description,
      color: node.color,
      userId: node.userId,
      externalUser: node.externalUser,
    })),
  });
}
